"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListContext = exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uniqid = _interopRequireDefault(require("uniqid"));

var _ListStyled = require("./List-styled");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var ListContext = (0, _react.createContext)({
  listContext: {
    nested: undefined,
    open: undefined,
    minmal: undefined,
    multiSelect: undefined,
    selectable: undefined
  }
});
exports.ListContext = ListContext;

var List =
/*#__PURE__*/
function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    var _this;

    _classCallCheck(this, List);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(List).call(this, props));
    _this.listId = _this.props.id || (0, _uniqid.default)();
    return _this;
  }

  _createClass(List, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          nested = _this$props.nested,
          open = _this$props.open,
          minimal = _this$props.minimal,
          multiSelect = _this$props.multiSelect,
          selectable = _this$props.selectable,
          other = _objectWithoutProperties(_this$props, ["children", "nested", "open", "minimal", "multiSelect", "selectable"]);

      var listContext = {
        nested: nested,
        open: open,
        minimal: minimal,
        multiSelect: multiSelect,
        selectable: selectable
      };
      var listNode = document.getElementById(this.listId);
      var listMaxHeight = 'none';

      if (open === false) {
        listMaxHeight = '0px';
      } else if (listNode && nested) {
        listMaxHeight = 0;

        for (var i = 0; i < listNode.childNodes.length; i++) {
          var child = listNode.childNodes[i];
          listMaxHeight = listMaxHeight + child.clientHeight;
        }

        listMaxHeight = listMaxHeight + 'px';
      }

      return _react.default.createElement(ListContext.Provider, {
        value: {
          listContext: listContext
        }
      }, _react.default.createElement(_ListStyled.StyledList, _extends({
        id: this.listId,
        maxHeight: listMaxHeight,
        nested: nested,
        open: open,
        minimal: minimal,
        selectable: selectable
      }, other), children));
    }
  }]);

  return List;
}(_react.Component);

exports.default = List;
List.propTypes = {
  /** The content of the component; can contain ListHeader, ListItem, and even another List. */
  children: _propTypes.default.node,

  /** Applied when the List is imbedded inside another List. */
  nested: _propTypes.default.bool,

  /** Whether the List should be collapsed or expanded. */
  open: _propTypes.default.bool,

  /** Minimal styling for the List */
  minimal: _propTypes.default.bool,

  /** Display check marks for selected ListItems, used with the `minimal` and `nested` properties */
  multiSelect: _propTypes.default.bool,

  /** Selectable styling for the List */
  selectable: _propTypes.default.bool
};
List.defaultProps = {};
List.displayName = 'List';